module.exports = "/_next/static/images/Personalization-xs-a6539787cded8f0080ee528d58fd1f5c.webp";